import React, { useState, useEffect } from 'react';
import debounce from 'debounce';

export const WindowSizeContext = React.createContext();

export const WindowSizeContextProvider = ({ children }) => {
  const [windowWidth, setWindowWidth] = useState();
  const [isMobile, setIsMobile] = useState();

  useEffect(() => {
    const { innerWidth } = window;

    const delayedCallback = debounce(() => {
      const { innerWidth } = window;
      setWindowWidth(innerWidth);
      setIsMobile(innerWidth < 768);
    }, 200);

    setWindowWidth(innerWidth);
    setIsMobile(innerWidth < 768);

    window.addEventListener('resize', delayedCallback);
    return () => {
      window.removeEventListener('resize', delayedCallback);
    };
  }, []);

  return (
    <WindowSizeContext.Provider
      value={{
        windowWidth,
        isMobile,
      }}
    >
      {children}
    </WindowSizeContext.Provider>
  );
};



// WEBPACK FOOTER //
// ./src/context/WindowSizeContext.js